import React from 'react';
import {Link as ScrollLink} from "react-scroll"
import TransitionLink from 'src/components/util/TransitionLink'

import * as S from './styled'

const NavbarItem = (props) => {
    return (
        <S.NavItem isButton={props.isButton}>
            {/* Is the section inside home? */}
            {props.insideHome

            // Is the current page home?
                ? (props.path === '/'

                // If yes, just scroll to section
                    ? <ScrollLink
                            href={props.scrollTo}
                            spy={true}
                            smooth={true}
                            offset={props.offset || 0}
                            to={props.scrollTo}>
                            {props.label}
                        </ScrollLink>

                    // If not, go to home and scroll after
                    : <TransitionLink
                        to="/"
                        state={{
                        SCROLLTO: props.scrollTo
                            ? ({
                                name: props.scrollTo,
                                offset: props.offset || 0
                            })
                            : false
                        }}>
                        {props.label}
                    </TransitionLink>)

                // Does this page have a section in home but have own page 
                // and the current page is home?
                : (props.insideHomeAndPage && props.path === '/' ?
                   <ScrollLink
                        href={props.scrollTo}
                        spy={true}
                        smooth={true}
                        offset={props.offset || 0}
                        to={props.scrollTo}>
                        {props.label}
                    </ScrollLink>

                // If there isnt a section and just a page, just change page
                : <TransitionLink to={props.routeTo}>
                    {props.label}
                </TransitionLink>)
}
        </S.NavItem>
    )
}

export default NavbarItem;